import {DATASET_MIXPANEL} from 'common/report/constants';

import {BaseClient} from '../utils/base-client';
import {processPropertyValues} from './utils';

class PeoplePropertyValuesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/engage/values`;
  }

  buildQueryParams(params) {
    /* eslint-disable camelcase */
    return {
      project_id: params.projectId,
    };
    /* eslint-enable camelcase */
  }

  buildRequestBody({
    propertyName,
    customProperty,
    dataGroupPropertyName = null,
    datasetId = DATASET_MIXPANEL,
    objectProperty = null,
    dataGroupId = null,
    tempDataGroupId = null,
    workspaceId = null,
  }) {
    let property = propertyName;
    if (customProperty) {
      property = JSON.stringify({...customProperty, ...(dataGroupPropertyName ? {dataGroupPropertyName} : {})});
    } else if (Array.isArray(propertyName)) {
      property = JSON.stringify(propertyName);
    }
    /* eslint-disable camelcase */
    return JSON.stringify({
      property,
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(tempDataGroupId ? {temp_data_group_id: tempDataGroupId} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(objectProperty
        ? {
            property: JSON.stringify(objectProperty),
          }
        : {}),
    });
    /* eslint-enable camelcase */
  }

  processResponse(response, {propertyName}) {
    return processPropertyValues(response.results, {propertyName});
  }
}

export const peoplePropertyValuesClient = new PeoplePropertyValuesClient();
